export default "__VITE_ASSET__C_fLEpn___"